import React from 'react'
import { components } from 'react-select'

const AddVariablePlaceholder = props => (
  <components.Placeholder {...props}>
    <i className="fas fa-plus-circle text-success mr-2" />
    <span className="text-dark">{props.children}</span>
  </components.Placeholder>
)

export default AddVariablePlaceholder
